// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';
import router from './router';

// 富文本
import 'bootstrap/js/modal.js';
import 'bootstrap/js/dropdown.js';
import 'bootstrap/js/tooltip.js';
import 'bootstrap/dist/css/bootstrap.css';

// import 'summernote';
// import 'summernote/dist/lang/summernote-zh-CN.js';

import 'summernote/dist/summernote.css';

import 'font-awesome/css/font-awesome.min.css';

// 引入less
// import ElementUI from 'element-ui';

// 注册ElementUI组件
// Vue.use(ElementUI);

import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/index.scss' // global css
import '@/icons' //svg icon

import './assets/less/index.less';

// 存储 图标 权限
import store from './store';
import '@/assets/icons';
import '@/assets/permission';

// 引入字体文件
import '@/assets/iconfont/iconfont.css';

Vue.config.productionTip = false;

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);


import './mixin.js';

import './components-common.js';
import './components-ticket-mobile.js';
import './components-setting.js';
import './components-ticket.js';
import './components-echarts.js';

import './assets/BudoDubboHttpApiJavascriptSdk.js';
import './assets/sdk.js';
import './assets/vue-filter.js';
import './assets/Permission.vue.js';
// $EventBus
// Vue.prototype.$EventBus = new Vue();

import { preventReClick } from "./assets/utils/resubmit";

var arrtoken = document.cookie.match(new RegExp('(^| )system_token=([^;]*)(;|$)')),
  arrtokenValue = (arrtoken != null) ? unescape(arrtoken[2]) : null;

// 配置应用信息和用户信息
Vue.config.permissionAppKey = () => { return 'taojin-merchant-vue'; };
Vue.config.permissionAccountToken = () => { return arrtokenValue; };

window.Vue = Vue;

new Vue({
  el: '#app',
	router,
	store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js